var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhiteDie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6174_625950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6174_625950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0625 17.0625C17.3542 16.7708 17.5 16.4167 17.5 16C17.5 15.5833 17.3542 15.2292 17.0625 14.9375C16.7708 14.6458 16.4167 14.5 16 14.5C15.5833 14.5 15.2292 14.6458 14.9375 14.9375C14.6458 15.2292 14.5 15.5833 14.5 16C14.5 16.4167 14.6458 16.7708 14.9375 17.0625C15.2292 17.3542 15.5833 17.5 16 17.5C16.4167 17.5 16.7708 17.3542 17.0625 17.0625ZM13.0625 13.0625C13.3542 12.7708 13.5 12.4167 13.5 12C13.5 11.5833 13.3542 11.2292 13.0625 10.9375C12.7708 10.6458 12.4167 10.5 12 10.5C11.5833 10.5 11.2292 10.6458 10.9375 10.9375C10.6458 11.2292 10.5 11.5833 10.5 12C10.5 12.4167 10.6458 12.7708 10.9375 13.0625C11.2292 13.3542 11.5833 13.5 12 13.5C12.4167 13.5 12.7708 13.3542 13.0625 13.0625ZM9.0625 9.0625C9.35417 8.77083 9.5 8.41667 9.5 8C9.5 7.58333 9.35417 7.22917 9.0625 6.9375C8.77083 6.64583 8.41667 6.5 8 6.5C7.58333 6.5 7.22917 6.64583 6.9375 6.9375C6.64583 7.22917 6.5 7.58333 6.5 8C6.5 8.41667 6.64583 8.77083 6.9375 9.0625C7.22917 9.35417 7.58333 9.5 8 9.5C8.41667 9.5 8.77083 9.35417 9.0625 9.0625ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteDie);
export default __webpack_public_path__ + "static/media/white_die.a55e2b5df0c14c28f81917483a0e00c5.svg";
export { ForwardRef as ReactComponent };